// extracted by mini-css-extract-plugin
export default {"body":"body--XCrc6skG1aOEXFw30dJ7","label":"label--JweEGHpLG8eW16qjZGxP","icon":"icon--SyjnnnX6XN3VLDA7FuF8"};